import React from 'react';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

function GraphView({ data }) {
    const chartData = data.map(item => ({
        GT: item.GT,
        FV1: isNaN(item.FV1) ? 0 : parseFloat(item.FV1)
    }));

    return (
        <ResponsiveContainer width="100%" height={400}>
            <LineChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="GT" tick={{ fontSize: 10 }} />
                <YAxis label={{ value: 'Fuel (FV1)', angle: -90, position: 'insideLeft' }} />
                <Tooltip />
                <Line type="monotone" dataKey="FV1" stroke="#00bcd4" strokeWidth={2} dot={{ r: 2 }} />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default GraphView;
